import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ReportsService as reportService } from '../reports/reports.service';
import { AgenciesService } from "../agencies/agencies.service";
import { SchoolsService } from '../schools/schools.service';
import { StaffService } from '../staff/staff.service';
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { Components } from "@ionic/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DatepickerDateCustomClasses } from "ngx-bootstrap/datepicker";
import { UserProfileStorageService } from '../services/user-profile-storage.service';

@Component({
  selector: 'schedule-reports',
  templateUrl: './schedule-reports.component.html',
  styleUrls: ['./schedule-reports.component.scss'],
})
export class ScheduleReportsComponent implements OnInit {
  public reportForm: FormGroup;
  @Input() modal: Components.IonModal;
  // @Input() staff;

  reportName: any;
  loading: boolean;
  Reports: any[];
  staffId:any;
  report: any;
  selectedMCC: any;
  disableStartEnd = true;
  start: any = null;
  end: any = null;
  startMinDate: Date = null;
  startMaxDate: Date = new Date();
  endMinDate: Date = null;
  endMaxDate: Date = null;
  fiscalYearList: any[];
  agencies: any[];
  schools: any[];
  activitiesList: any = [];
  masterCalendarList: any[];
  selectAgencyFormControl = new FormControl();
  searchAgencyInputTxt = new FormControl('');
  searchSchoolInputTxt = new FormControl('');
  isSchoolsListUpdated: boolean = false;

  selectSchoolFormControl = new FormControl();
  filteredAgencyOptions: Observable<any[]>;
  multipleActivities = true;
  selectedAgencyIds: any;
  selectedSchoolIds: any;
  displayMultipleSelection:boolean = false;
  agenciesList: any;
  schoolsList: any[];
  selectedSchool: any[];
  selectedAgency: any[];

  @ViewChild("searchAgency", { static: false }) searchAgencyTextBox: ElementRef;
  @ViewChild("searchSchool", { static: false }) searchSchoolTextBox: ElementRef;
  displayMultipleSchoolSelection: boolean = true;
  filteredSchoolOptions: any;
  disableActivities: boolean = false;
  tempActivitiesList: any[];
  disableAgency: boolean = false;

  hideAgency: boolean = true;
  agencyId: any = -1;
  filteredSchoolOptions2 = [];
  SelectedfilteredSchoolOptions = [];
  isSelectedMCCChanged: boolean = false;
  disableSchools = false;
  multipleAgencies = false;
  selectedAgencyId: any = -1;
  enabledDates: any = [];
  allDates: any = [];
  highlightOnlyReportDates: DatepickerDateCustomClasses[] = []; // May not be needed for schedule reports
  availableDate: any = [];

  @ViewChild("multiSelect", { static: false }) multiSelect;
  public loadContent: boolean = false;
  public data = [];
  public settings = {};
  public selectedItems = [];
  dropDownSelect = false;

  constructor(private reportService: reportService,
    public formBuilder: FormBuilder,
    public agenciesService: AgenciesService,
    public schoolsService: SchoolsService,
    public staffService: StaffService,private userProfileStorage: UserProfileStorageService
  ) {
    this.reportForm = formBuilder.group({
      agencies: [[], [Validators.required]],
      startDate: ["", [Validators.required]],
      endDate: ["", [Validators.required]],
      masterCalendarId: ["0", Validators.required],
      fiscalYearId: [0, Validators.required],
      schoolmultilist: [[], [Validators.required]],
      schoolId: [[], [Validators.required]],
      activities: [[]]
    });
  }

  ngOnInit() {
    this.getStaffInfoByLoginName();
    console.log("***************STAFF***********", this.staffId)

    this.agencyId = this.profile.agency;

    // Settings for school multi-select dropdown
    this.settings = {
      singleSelection: false,
      idField: 'id',
      textField: 'schoolName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Schools found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };

    this.startMaxDate = new Date();
    this.endMaxDate = new Date();
    this.fetchMasterCalendars()
    this.filteredAgencyOptions = this.searchAgencyInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._agencyFilter(name)));
    this.filteredSchoolOptions = this.searchSchoolInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._schoolFilter(name)));
  }

  fetchData() {
    // Called when clicking on a specific report
    this.loading = true;
    this.reportService.getReports().subscribe((data: any) => {
      console.log("fetchData(): data from service:", data);
      this.Reports = data;
      this.loading = false;
    });
  }

  // fetch agency data
  fetchAgencyList() {
    if (
      this.hasRoles([5, 6]) &&
      this.report.reportName.includes("Raw Attendance Report") ||
      this.report.reportName.includes("Daily Attendance Backup") ||
      this.report.reportName.includes("Absence Roster") ||
      this.report.reportName.includes("Early Release Forms")
    ) {
      this.displayMultipleSelection = false;
    }
    else {
      this.displayMultipleSelection = true;
    }

    if (this.hasRoles([5, 6]) &&
      (
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Performance Summary") ||
        this.report.reportName.includes("Student Attendance Audit Report")
      )) {
      this.displayMultipleSchoolSelection = true;
      this.displayMultipleSelection = true;
    }
    else {
      this.displayMultipleSchoolSelection = false;
      this.displayMultipleSelection = false;
    }

    if (!this.displayMultipleSchoolSelection) {
      this.reportForm.get('schoolmultilist').clearValidators();
      this.reportForm.get('schoolmultilist').updateValueAndValidity();
    }

    this.checkFormValidity();

    var agObservable$;
    if (this.displayMCYear())
      agObservable$ = this.agenciesService.getAgenciesByMCC(this.selectedMCC);
    else
      agObservable$ = this.agenciesService.getAgencies();

    //this.agenciesService.getAgencies()
    agObservable$.subscribe((data: any) => {
      console.log("fetchAgencyList(): data from agencies service:", data);
      this.agenciesList = data
        .filter((x) => x.isActive)
        .sort((a, b) => a.name.localeCompare(b.name));

      if (this.report.reportName.includes("Grant Export")) {
        this.agenciesList.unshift({
          id: -1,
          name: "All Agencies",
          shortCode: "All Agencies",
        });

        let agencyEvent = {
          isUserInput: true,
          source: { selected: true, value: "All Agencies" },
        };

        this.selectionAgencyChange(agencyEvent);

        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").setValue([-1]);
      }
      else if (
        (
          this.report.reportName.includes("Raw Attendance Report") ||
          this.report.reportName.includes("Offline Attendance") ||
          this.report.reportName.includes("Absence Roster") ||
          this.report.reportName.includes("Early Release Forms") ||
          this.report.reportName.includes("Attendance Summary") ||
          this.report.reportName.includes("Student Enrollment Report") ||
          this.report.reportName.includes("Student Attendance Audit Report") ||
          this.report.reportName.includes("Student Roster Report") ||
          this.report.reportName.includes("Performance Summary")
        ) &&
        this.hasRoles([6, 8])
      ) {
        this.disableAgency = true;
        const agencies = [];
        this.displayMultipleSelection = false;
        agencies.push(this.profile.agency);
        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").patchValue(agencies);

        if (
          this.report.reportName.includes("Raw Attendance Report") ||
          this.report.reportName.includes("Offline Attendance") ||
          this.report.reportName.includes('Absence Roster') ||
          this.report.reportName.includes("Performance Summary")
        ) {
          this.fetchSchools(this.profile.agency);
        }
      } else if (
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Student Roster Report") ||
        this.report.reportName.includes("Performance Summary")
      ) {
        this.agenciesList.unshift({ id: -1, name: "All Agencies", shortCode: "All Agencies", });
        let agencyEvent = {
          isUserInput: true,
          source: { selected: true, value: "All Agencies" },
        };
        this.selectionAgencyChange(agencyEvent);
        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").setValue([-1]);
      }
      console.log("this.agenciesList", this.agenciesList);
      this.filteredAgencyOptions = this.searchAgencyInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._agencyFilter(name))
      );
    });
  }

  private _agencyFilter(name: string): String[] {
    const filterValue = name.toLowerCase();
    this.setAgencySelectedValues();
    this.selectAgencyFormControl.patchValue(this.selectedAgency);
    let filteredList = this.agenciesList.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
    filteredList.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    var allAgencies = "All Agencies";
    filteredList.unshift(
      filteredList.splice(
        filteredList.findIndex((item) => item.name === allAgencies),
        1
      )[0]
    );
    return filteredList;
  }

  onMCChange(event) {
    if (this.reportForm.get('schoolmultilist')) {
      this.filteredSchoolOptions2 = [];
      this.SelectedfilteredSchoolOptions = [];;
      this.reportForm.get('schoolmultilist').patchValue('');
    }

    if (this.reportForm.get("activities")) {
      this.reportForm.get("activities").patchValue("");
    }

    if (this.reportForm.get("startDate")) {
      this.reportForm.get("startDate").patchValue("");
    }

    if (this.reportForm.get("endDate")) {
      this.reportForm.get("endDate").patchValue("");
    }

    this.isSelectedMCCChanged = true;
    this.selectedMCC = event[0].data.masterCalendarCode;
    this.disableStartEnd = false;
    this.start = null;
    this.end = null;
    this.startMinDate = moment("01/01/1000").toDate();
    this.startMaxDate = moment().toDate();
    this.endMinDate = this.startMinDate;
    this.endMaxDate = this.startMaxDate;
    this.start = moment(event[0].data.fromDate).format("MM/DD/YYYY");
    this.end = moment(event[0].data.toDate).format("MM/DD/YYYY");

    if (this.reportForm.get("startDate"))
      this.reportForm.get("startDate").setValue(this.start);

    if (!this.report.reportName.includes("Student Enrollment Report")) {
      this.reportForm.get("endDate").setValue(this.end);
    }
    else {
      if (this.hasRoles([8]))
        this.reportForm.get('schoolmultilist').clearValidators();
    }

    const agencyId = document.getElementById("");

    if (this.hasRoles([6, 8])) {
      this.fetchSchools(this.profile.agency);
    } else {
      if (!this.report.reportName.includes('Absence Roster')) {
        this.disableAgency = false;
      }
    }

    this.fetchAgencyList();
  }

  cancelReports() {
    this.modal.dismiss("cancel");
  }

  onAgencyChange(event) {
    if (this.displayStart() && this.reportForm.get("startDate")) {
      this.reportForm.get("startDate").patchValue("");
    }

    if (this.displayEnd() && this.reportForm.get("endDate")) {
      this.reportForm.get("endDate").patchValue("");
    }

    const agencies = [];
    event.forEach((element) => {
      agencies.push(element.data.id);
    });

    if (this.report.reportName.includes("Daily Attendance Backup") || this.report.reportName.includes('Early Release Forms')) {
      this.multipleAgencies = false;
      this.selectedAgencyId = event[0].data.id;
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }
      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }
      return;
    }

    if (this.displaySchools() && this.hasRoles([5]) && !this.report.reportName.includes("Attendance Summary")) {
      this.disableSchools = true;

      if (event.length === 0) {
        this.schoolsList = [];
      }

      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }

      if (event.length > 1) {
        this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });
        this.reportForm.get("schoolId").setValue(-1);
        this.selectedSchool = this.schoolsList.map((x) => {
          return x.schoolName;
        });
        this.selectSchoolFormControl.patchValue(this.selectedSchool);
        this.disableSchools = true;
      }
    }

    if (this.reportForm.get("agencies"))
      this.reportForm.get("agencies").patchValue(agencies);

    if ((this.report.reportName.includes("Attendance Summary") ||
      this.report.reportName.includes("Absence Roster") ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Attendance Audit Report") ||
      this.report.reportName.includes("Student Roster Report")) &&
      !this.report.reportName.includes("Provider")
    ) {
      this.selectedAgencyId = event[0].data.id;
    }
  }

  onSchoolChange(event) {
    var name = this.report.reportName;
    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];

    const requestReport = this.reportForm.value;

    if (this.hasRoles([6, 8])) {
      if (this.agencyId && event[0].data.id) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;
        this.reportService
          .getReportDates(currentAgencyId, event[0].data.id, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    } else {
      if (requestReport.agencies && event[0].data.id) {
        this.reportService
          .getReportDates(requestReport.agencies, event[0].data.id, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }

    console.log("event[0].data", event[0].data.id);

    this.checkFormValidity();
    this.fetchActivities(event[0].data.id);
  }

  onActivityChange(event) {
    this.tempActivitiesList = [];
    event.forEach((element) => {
      this.tempActivitiesList.push(element.data.activityId);
    });
  }

  onSchoolChangeMultiSelect(selectedEvent) {
    var name=this.report.reportName;
    let school = this.schoolsList.filter((x) => x.schoolName === selectedEvent.source.value);
    let event = [{ data: { id: school[0].id } }];

    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];

    const requestReport = this.reportForm.value;
    if (this.hasRoles([6, 8])) {
      if (this.agencyId && event[0].data.id) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;

        this.reportService
          .getReportDates(currentAgencyId, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    } else {
      if (requestReport.agencies && event[0].data.id) {
        this.reportService
          .getReportDates(requestReport.agencies, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }
    this.fetchActivities(event[0].data.id);
  }

  enableReportAvailableDates(reportAvailableDate) {
    if (this.report.reportName.includes("Daily Attendance Backup") || this.report.reportName.includes("Early Release Forms")) {
      this.enabledDates = reportAvailableDate.map((f) => Date.parse(f.to_char + " 23:59:59"));
      let reportDates = reportAvailableDate.map((f) => f.to_char + " 23:59:59");
      reportDates.forEach((date) => {
        let highlightedTo = {
          date: new Date(date),
          classes: ["highlight-reportdate"],
        };
        this.highlightOnlyReportDates.push(highlightedTo);
      });
    }
  }

  selectionAgencyChange(event) {
    console.log("Selection agency change called");
    this.selectedSchool = [];

    this.selectSchoolFormControl.patchValue(this.selectedSchool);

    if (event.isUserInput) {
      if (event.source.selected == true) {
        event.source.value === "All Agencies" ? (this.selectedAgency = this.agenciesList.map((x) => {
          return x.shortCode;
        }))
          : this.selectedAgency.push(event.source.value);
      } else {
        if (event.source.value === "All Agencies") {
          this.selectedAgency = [];
        } else {
          let index = this.selectedAgency.indexOf(event.source.value);
          this.selectedAgency.splice(index, 1);
          let allindex = this.selectedAgency.indexOf("All Agencies");
          this.selectAgencyFormControl.value.includes("All Agencies") ? this.selectedAgency.splice(allindex, 1) : "";
        }
      }
      this.selectAgencyFormControl.patchValue(this.selectedAgency);
      this.onAgencyChangeMultiSelect(event);
    }
  }

  onAgencyChangeMultiSelect(selectedEvent) {
    let agency = this.agenciesList.filter((x) => x.shortCode === selectedEvent.source.value);
    let event = [{ data: { id: agency[0].id } }];
    const agencies = [];

    event.forEach((element) => {
      agencies.push(element.data.id);
    });

    // if report selected in 'Grant Export', user can only choose 1 agency
    if (this.report.reportName.includes("Grant Export")) {
      if (agencies.includes(-1)) {
        this.multipleAgencies = false;
        this.reportForm.get("agencies").setValue([-1]);
      } else {
        this.multipleAgencies = true;
      }
    }

    if (this.report.reportName.includes("Daily Attendance Backup") ||
      this.report.reportName.includes('Early Release Forms') ||
      this.report.reportName.includes('Absence Roster')) {
      this.multipleAgencies = false;
      this.selectedAgencyId = event[0].data.id;
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }
      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }
      return;
    }

    if (this.displaySchools() && this.hasRoles([5]) && !this.report.reportName.includes("Attendance Summary")) {
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }

      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }

      if (event.length > 1) {
        this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });
        this.reportForm.get("schoolId").setValue(-1);
        this.selectedSchool = this.schoolsList.map((x) => {
          return x.schoolName;
        });
        this.selectSchoolFormControl.patchValue(this.selectedSchool);
        this.disableSchools = true;
      }
    }

    if (this.reportForm.get("agencies"))
      this.reportForm.get("agencies").patchValue(agencies);
    if (
      (this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Absence Roster") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Student Roster Report")
      ) &&
      !this.report.reportName.includes("Provider")
    ) {
      this.selectedAgencyId = event[0].data.id;
      if (this.selectedAgencyId == -1 && this.isSelectedMCCChanged == true) {
        this.fetchSchools(this.selectedAgencyId);
        this.isSelectedMCCChanged = false;
      }
    }
  }

  openedAgencyChange(e) {
    this.searchAgencyInputTxt.patchValue("");
    if (e == true) {
      this.searchAgencyTextBox.nativeElement.focus();
    }
    else {
      if (this.reportForm.get('schoolmultilist')) {
        this.filteredSchoolOptions2 = [];
        this.SelectedfilteredSchoolOptions = [];
        this.reportForm.get('schoolmultilist').patchValue('');
      }

      if (this.reportForm.get("activities")) {
        this.reportForm.get("activities").patchValue("");
      }

      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").patchValue("");
      }

      if (this.reportForm.get("endDate")) {
        this.reportForm.get("endDate").patchValue("");
      }

      if (this.hasRoles([8])) {
        this.fetchSchools(this.profile.agency);
      } else {
        if (!this.report.reportName.includes('Absence Roster'))
          this.fetchSchools(this.profile.agency);
      }
    }
  }

  openedSchoolChange(e) {
    this.searchSchoolInputTxt.patchValue("");
    if (e == true) {
      this.searchSchoolTextBox.nativeElement.focus();
    }
  }

  setAgencySelectedValues() {
    if (this.selectAgencyFormControl.value && this.selectAgencyFormControl.value.length > 0) {
      this.selectAgencyFormControl.value.forEach((e) => {
        if (this.selectedAgency.indexOf(e) == -1) {
          this.selectedAgency.push(e);
        }
      });
    }
  }

  setSchoolSelectedValues() {
    if (this.selectSchoolFormControl.value && this.selectSchoolFormControl.value.length > 0) {
      this.selectSchoolFormControl.value.forEach((e) => {
        if (this.selectedSchool.indexOf(e) == -1) {
          this.selectedSchool.push(e);
        }
      });
    }
  }

  selectionSchoolChange(event) {
    if (event.isUserInput) {
      if (event.source.selected == true && !this.isSchoolsListUpdated) {
        this.isSchoolsListUpdated = true;
        if (event.source.value === "All Schools") {
          this.selectedSchool = this.schoolsList.map((x) => x.schoolName);
        } else {
          if (!this.selectedSchool.includes(event.source.value)) {
            this.selectedSchool = [...this.selectedSchool, event.source.value];
          }
        }
        this.isSchoolsListUpdated = false;
      } else {
        if (event.source.value == "All Schools") {
          this.selectedSchool = [];
        } else {
          let index = this.selectedSchool.indexOf(event.source.value);
          this.selectedSchool.splice(index, 1);
          let allindex = this.selectedSchool.indexOf("All Schools");
          this.selectSchoolFormControl.value.includes("All Schools") ? this.selectedSchool.splice(allindex, 1) : "";
        }
      }
      this.selectSchoolFormControl.patchValue(this.selectedSchool);
      this.onSchoolChangeMultiSelect(event);
    }
  }

  getStaffInfoByLoginName() {
    this.staffService.getStaffInfoByLoginName().subscribe(
      (staffInfo) => {
        if (staffInfo && staffInfo.staff && staffInfo.staff[0]) {
          this.staffId = staffInfo;
        } else {
          console.error('Staff info is invalid or empty');
          this.staffId = null;
        }
      },
      (error) => {
        console.error('Error fetching staff info:', error);
        this.staffId = null;
      }
    );
  }

  fetchSchools(id) {
    this.schoolsList = [];
    this.disableSchools = false;
    console.log("report.reportName ", this.report.reportName);

    if (!this.report.reportName.includes("Global Report") && !this.hasRoles([8])) {
      let selectedAgencyIds = this.displayMultipleSelection == true ? this.agenciesList.filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode)).map((x) => { return x.id; }) : id.toString();

      selectedAgencyIds = this.displayMultipleSelection == true ? selectedAgencyIds.map((e) => e.toString().replace(/\s/g, "")).join(",") : id.toString();

      var scObservable$;
      if (this.displayMCYear())
        scObservable$ = this.schoolsService.getSchoolsByAgencyIdsandByMCC(selectedAgencyIds, this.selectedMCC);
      else {
        scObservable$ = this.schoolsService.getSchoolsByAgencyIds(selectedAgencyIds);
      }

      scObservable$
        .subscribe((data: any) => {
          this.schoolsList = data.sort((a, b) => a.schoolName.localeCompare(b.schoolName));
          //debugger;
          if (this.displayMultipleSchoolSelection && this.reportForm.get("schoolId")) {
            this.reportForm.get("schoolId").setValue(-1);
          }

          this.disableSchools = this.schoolsList.length > 0 ? false : true;

          this.searchSchoolInputTxt.valueChanges.pipe(
            startWith<string>(""),
            map((name) => this._schoolFilter(name))
          ).subscribe((data: any) => {
            this.filteredSchoolOptions2 = data;
          });

        });
    } else {
      this.schoolsService.getSchoolsByAgency(id).subscribe((data: any) => {
        console.log("fetchAgencyList(): data from agencies service:", data);
        this.schoolsList = data.sort((a, b) => a.schoolName.localeCompare(b.schoolName));
        if (
          this.report.reportName.includes("Participation") ||
          this.report.reportName.includes("Unduplicated Student Names") ||
          this.report.reportName.includes("Attendance Summary") ||
          this.report.reportName.includes("Student Enrollment Report") ||
          this.report.reportName.includes("Offline Attendance") ||
          this.report.reportName.includes("Raw Attendance Report") ||
          this.report.reportName.includes("Student Roster Report") ||
          this.report.reportName.includes("Performance Summary")
        ) {
          if (!this.hasRoles([8])) {
            this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });
            if (this.reportForm.get("schoolId"))
              this.reportForm.get("schoolId").setValue(-1);
          }
        }
        this.disableSchools = this.schoolsList.length > 0 ? false : true;
      });
    }

    if (!this.displayMultipleSchoolSelection) {
      this.reportForm.get('schoolmultilist').clearValidators();
      this.reportForm.get('schoolmultilist').updateValueAndValidity();
    }
  }

  private _schoolFilter(name: string): String[] {
    const filterValue = name.toLowerCase();
    this.setSchoolSelectedValues();
    this.selectSchoolFormControl.patchValue(this.selectedSchool);
    let filteredList = this.schoolsList.filter((option) => option.schoolName.toLowerCase().indexOf(filterValue) === 0);
    filteredList.sort((a, b) => a.schoolName.toLowerCase() > b.schoolName.toLowerCase() ? 1 : -1);
    // var allschools = "All Schools";
    // filteredList.unshift(filteredList.splice(filteredList.findIndex((item) => item.schoolName === allschools), 1)[0]);
    //// console.log("This is the filtered list: -------------------?" + filteredList);
    return filteredList;
  }

  // fetches user's profile details
  get profile() {
    return this.userProfileStorage.profile;
  }

  hasRoles(roles: number[]): boolean {
    if (this.profile) {
      for (const aRole of this.profile.roles) {
        if (roles.includes(aRole)) {
          return true;
        }
      }
    }
    return false;
  }

  fetchMasterCalendars() {
    this.reportService.getMasterCalendarsForReports().subscribe((data: any) => {
      this.masterCalendarList = data.filter(x => x.isActive);
      console.log('generatereportpopup:fetchFiscalYear(): data from fiscalYear service:', this.fiscalYearList);
    });
  }

  //fetch activities
  fetchActivities(schoolId) {
    this.disableActivities = false;
    if (this.displayMultipleSelection) {
      this.selectedSchoolIds = this.schoolsList
        .filter((x) => this.selectSchoolFormControl.value.includes(x.schoolName))
        .map((x) => { return x.id; });

      this.selectedSchoolIds = this.selectedSchoolIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      this.selectedAgencyIds = this.agenciesList
        .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
        .map((x) => { return x.id; });

      this.selectedAgencyIds = this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      if (this.selectedSchoolIds.split(",").length > 1 || this.selectedAgencyIds.split(",").length > 1) {
        this.disableActivities = true;
        return;
      }
    } else if ((this.report.reportName.includes('Offline Attendance') ||
      this.report.reportName.includes('Attendance Summary') ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report") ||
      this.report.reportName.includes("Performance Summary")
    ) && this.hasRoles([6, 7])) {
      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.profile.agency;
    } else {
      if ((this.report.reportName.includes('Absence Roster') ||
        this.report.reportName.includes('Offline Attendance') ||
        this.report.reportName.includes('Early Release Forms') ||
        this.report.reportName.includes("Performance Summary")) && this.hasRoles([6, 8])) {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyId = this.profile.agency;

        console.log("profile. agency id is   ", this.profile.agency)
        console.log("this.agencyid agency id is   ", this.agencyId)
      } else {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyIds = this.selectedAgencyId;
      }
    }

    console.log("selectedSchoolIds", this.selectedSchoolIds);
    console.log("selectedAgencyIds", this.selectedAgencyIds);

    var agencyId = this.selectedAgencyId;
    var masterCalendarCode = this.selectedMCC;
    if (this.selectedMCC) {
      this.agenciesService.getActivities(this.selectedAgencyIds, this.selectedSchoolIds, masterCalendarCode).subscribe((data: any) => {
        console.log("this.activitiesList", data);
        this.activitiesList = data.map((item) => ({
          activityId: item.scheduledActivity.id,
          activityName: item.activityName + " - " + item.scheduledActivity.groupName,
        }));
      });
    }
  }

  changeStartDate(event) {
    if (this.reportForm.get("endDate"))
      if (this.reportForm.get("startDate"))
        this.reportForm.get("endDate").setValue("");

    if (event == "Invalid Date") {
      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").setValue("");
      }
    } else if (event != "") {
      console.log(event);
      let inputDay = new Date(event);

      if (inputDay > this.startMaxDate) {
        if (this.reportForm.get("startDate")) {
          this.reportForm.get("startDate").setValue(this.startMaxDate);
          return;
        }
      }

      if (inputDay < this.startMinDate) {
        if (this.reportForm.get("startDate")) {
          this.reportForm.get("startDate").setValue(this.startMinDate);
          return;
        }
      }

      if (
        this.report.reportName.includes("Raw Attendance") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Absence Roster") ||
        this.report.reportName.includes("Performance Summary")
      ) {
        this.endMinDate = new Date(event);
        this.endMaxDate = new Date(event);
        this.endMaxDate.setDate(this.endMaxDate.getDate() + 60);

        let today = new Date();
        let tempEndDate = this.endMaxDate <= today ? this.endMaxDate : today;
        this.endMaxDate = tempEndDate;

        this.reportForm.get("endDate").setValue(this.endMaxDate);
      } else if (this.report.reportName.includes("Student Enrollment Report")) {
        this.endMinDate = new Date(event);
        this.endMaxDate = new Date(event);
        this.endMaxDate.setDate(this.endMaxDate.getDate() + 366);
        let today = new Date();
        let tempEndDate = this.endMaxDate <= today ? this.endMaxDate : today;
        this.endMaxDate = tempEndDate;
      }
      else if (this.report.reportName.includes("Performance Summary")) {
        this.endMinDate = new Date(event);
      }

      if (
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Performance Summary")
      ) {if(this.reportForm.get("startDate") && this.reportForm.get("startDate").value !== null && this.reportForm.get("startDate").value !=='')
        {  let stdate = this.reportForm.get("startDate").value;
          this.endMaxDate = new Date(stdate);
          this.endMinDate = new Date(stdate);
           if(this.SelectedfilteredSchoolOptions.length > 10)
              {

                this.endMaxDate.setDate(this.endMaxDate.getDate() + 31);

              }
              else{
                this.endMaxDate.setDate(this.endMaxDate.getDate() + 92);
              }
            }
      }
    }
  }

  changeEndDate(event) {
    let inputDay = new Date(event);
    if (inputDay > this.endMaxDate) {
      this.reportForm.get("endDate").setValue(this.endMaxDate);
      return;
    }
    if (inputDay < this.endMinDate) {
      this.reportForm.get("endDate").setValue(this.endMinDate);
      return;
    }
    console.log(event);
    if (this.report.reportName.includes("Performance Summary")) {
      this.startMaxDate = new Date(event);
    }
  }

  //Insert here to display Master Calendar Code in the Report
  displayMCYear() {
    return (this.report.reportName.includes("Attendance Summary")
      || this.report.reportName.includes("Student Attendance Audit Report")
      || this.report.reportName.includes('Absence Roster')
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes("Student Roster Report") && !this.report.reportName.includes("BTB Attendance Summary (by Provider) [report]"));
  }

  //Insert here to display Agency in the Report
  displayAgency() {
    return (this.report.reportName.includes("Attendance Summary")
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes("Offline Attendance")
      || this.report.reportName.includes("Performance Summary")
      || this.report.reportName.includes("Raw Attendance Report")
      || this.report.reportName.includes('Early Release Forms')
      || this.report.reportName.includes('Absence Roster')
      || this.report.reportName.includes('Student Roster Report')
      || this.report.reportName.includes("Student Attendance Audit Report")
      || (this.report.reportName.includes("Daily Attendance Backup") && !this.hasRoles([6, 8])) ? true : false);
  }

  //Insert here to display Schools
  displaySchools() {
    return (((this.report.reportName.includes('Attendance Summary') && !this.report.reportName.includes('BTB Attendance Summary (by Provider) [report]'))
      || (this.report.reportName.includes("Student Attendance Audit Report"))
      || this.report.reportName.includes('Offline Attendance')
      || this.report.reportName.includes('Early Release Forms')
      || this.report.reportName.includes('Absence Roster')
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes('Performance Summary')
      || this.report.reportName.includes('Raw Attendance Report')
      || this.report.reportName.includes('Student Roster Report')
      || this.report.reportName.includes('Daily Attendance Backup')) ? true : false)
  }

  //Insert here to display Activities in the Report
  displayActivities() {
    return (
      (
        this.report.reportName.includes("Attendance Summary")
        || this.report.reportName.includes("Student Enrollment Report")
        || this.report.reportName.includes("Student Attendance Audit Report")
        || this.report.reportName.includes("Student Roster Report")
      ) &&
      !this.report.reportName.includes("(by Provider)") &&
      !this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code")
    );
  }

  //Insert here to display Start Date in the Report
  displayStart() {
    return (this.report.reportName.includes('Activity')
      || this.report.reportName.includes('HS')
      || this.report.reportName.includes('Dosage')
      || this.report.reportName.includes('Progress By Grant Type')
      || this.report.reportName.includes('Projection')
      || this.report.reportName.includes('Participation')
      || this.report.reportName.includes('Daily Attendance Backup')
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes('Early Release Forms')
      || this.report.reportName.includes('Absence Roster')
      || this.report.reportName.includes('Raw Attendance Report')
      || this.report.reportName.includes('Offline Attendance')
      || this.report.reportName.includes("Student Attendance Audit Report")
      || this.report.reportName.includes('Summary')
      || this.report.reportName.includes('Total Daily Attendance Per Site by Enrichment Code')
      || this.report.reportName.includes('Unduplicated Student Names') ? true : false)
  }

  //Insert here to display End Date in the Report
  displayEnd() {
    return (this.report.reportName.includes("Activity")
      || this.report.reportName.includes("HS")
      || this.report.reportName.includes("Dosage")
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes("Progress By Grant Type")
      || this.report.reportName.includes("Participation")
      || this.report.reportName.includes("Raw Attendance Report")
      || this.report.reportName.includes("Offline Attendance")
      || this.report.reportName.includes("Projection")
      || this.report.reportName.includes("Summary")
      || this.report.reportName.includes("Student Attendance Audit Report")
      || this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code")
      || this.report.reportName.includes("Unduplicated Student Names") ? true : false)
  }

  checkFormValidity(): void {
    if (this.reportForm.invalid) {
      Object.keys(this.reportForm.controls).forEach((controlName) => {
        const control = this.reportForm.get(controlName);
        if (control.invalid) {
          console.log("Control '${controlName}' is invalid.");
          if (control.errors) {
            Object.keys(control.errors).forEach((errorKey) => {
              console.log("  - ${errorKey}: ${control.errors.[errorKey]}");
            });
          }
        }
      });
    } else {
      console.log("Form is valid");
    }
  }

  get f() {
    return this.reportForm.controls;
  }

  public onFilterChange(item: any) {
    console.log(this.SelectedfilteredSchoolOptions);
  }

  public onItemSelect(item: any) {
    this.SelectedfilteredSchoolOptions.push(item);
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").patchValue(item.id);
  }

  public onDeSelect(item: any) {
    this.SelectedfilteredSchoolOptions = this.SelectedfilteredSchoolOptions.filter((x) => x.id !== item.id);
    console.log(this.SelectedfilteredSchoolOptions);
    if(this.SelectedfilteredSchoolOptions.length == 0)
    this.reportForm.get("schoolId").patchValue('');
    this.activitiesList  = [];
  }

  public onSelectAll(items: any) {
    this.SelectedfilteredSchoolOptions = [];
    this.SelectedfilteredSchoolOptions = items;
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").patchValue(-1);
  }

  public onDeSelectAll(items: any) {
    this.SelectedfilteredSchoolOptions = [];
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").patchValue('');
  }

  public onDropDownClose(items: any) {
    if (this.dropDownSelect) {
      if (this.reportForm.get("activities")) {
        this.reportForm.get("activities").patchValue("");
      }

      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").patchValue("");
      }

      if (this.reportForm.get("endDate")) {
        this.reportForm.get("endDate").patchValue("");
      }

      this.selectedAgencyIds = this.displayMultipleSelection ?
        this.agenciesList
          .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
          .map((x) => {
            return x.id;
          }) : this.profile.agency.toString();

      this.selectedAgencyIds = this.displayMultipleSelection ? this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",") : this.selectedAgencyIds;

      this.selectedSchoolIds = this.SelectedfilteredSchoolOptions.map((x) => {
        return x.id;
      });
      this.selectedSchoolIds = this.selectedSchoolIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      this.onSchoolDropdownCloseMultiSelect(this.selectedAgencyIds, this.selectedSchoolIds);
      this.dropDownSelect = false;
    }
  }

  onSchoolDropdownCloseMultiSelect(selectedmultiagencyids, selectedmultischoolids) {
    var name = this.report.reportName;
    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];
    const requestReport = this.reportForm.value;

    if (this.hasRoles([6, 8])) {
      if (this.agencyId) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : selectedmultiagencyids;
        if (selectedmultischoolids.length > 0) {
          this.reportService
            .getReportDatesforMulti(currentAgencyId, selectedmultischoolids, name)
            .subscribe((dates) => {
              this.availableDate = dates;
              this.enableReportAvailableDates(this.availableDate);
            });
        }
      }
    } else {
      if (selectedmultiagencyids.length > 0 && selectedmultischoolids.length > 0) {
        this.reportService
          .getReportDatesforMulti(selectedmultiagencyids, selectedmultischoolids, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }

    if (this.SelectedfilteredSchoolOptions.length == 1 && this.SelectedfilteredSchoolOptions[0].id != -1)
      this.fetchActivitiesForMulti(this.SelectedfilteredSchoolOptions[0].id);
    else
      this.activitiesList = [];
  }

  fetchActivitiesForMulti(schoolId) {
    this.disableActivities = false;
    if (this.displayMultipleSelection) {
      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.agenciesList
        .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
        .map((x) => {
          return x.id;
        });

      this.selectedAgencyIds = this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      if (this.SelectedfilteredSchoolOptions.length > 1 || this.selectedAgencyIds.split(",").length > 1) {
        this.disableActivities = true;
        return;
      }
    }
    else if ((this.report.reportName === 'Offline Attendance' ||
      this.report.reportName === 'Attendance Summary' ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report") ||
      this.report.reportName.includes("Performance Summary")
    ) && this.hasRoles([6, 7])) {
      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.profile.agency;
    }
    else {
      if ((this.report.reportName === 'Absence Roster' || this.report.reportName === 'Offline Attendance' || this.report.reportName === 'Early Release Forms' ||
        this.report.reportName.includes("Performance Summary")) && this.hasRoles([6, 8])) {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyId = this.profile.agency;

        console.log("profile. agency id is   ", this.profile.agency)
        console.log("this.agencyid agency id is   ", this.agencyId)
      } else {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyIds = this.selectedAgencyId;
      }
    }

    console.log("selectedSchoolIds", this.selectedSchoolIds);
    console.log("selectedAgencyIds", this.selectedAgencyIds);

    var agencyId = this.selectedAgencyId;
    var masterCalendarCode = this.selectedMCC;
    if (this.selectedMCC) {
      this.agenciesService.getActivities(this.selectedAgencyIds,this.SelectedfilteredSchoolOptions[0].id,masterCalendarCode).subscribe((data: any) => {
          console.log("this.activitiesList", data);
          this.activitiesList = data.map((item) => ({
            activityId: item.scheduledActivity.id,
            activityName: item.activityName + " - " + item.scheduledActivity.groupName,
          }));
        });
    }
  }

  convertStringArrayToIntArray(stringArray: string[]): number[] {
    return stringArray.map(str => {
      const num = parseInt(str, 10); // Parse as base 10
      if (isNaN(num)) {
        console.error(`Could not convert '${str}' to an integer.`);
        return NaN; // Or handle the error differently (e.g., return a default value, throw an error)
      }
      return num;
    }).filter(num => !isNaN(num)); // filter out NaN values
  }

  // Schedule reports
  scheduleReport(report) {
    const pipe = new DatePipe('en-US');
    const requestReport = this.reportForm.value;

    requestReport.schools = this.displayMultipleSchoolSelection && this.selectedSchoolIds.toString().includes(',')
      ? this.convertStringArrayToIntArray(this.selectedSchoolIds.split(","))
      : [this.selectedSchoolIds];

    requestReport.activities = this.tempActivitiesList;

    // Call the method to get staff info and subscribe to the result
    if (this.staffId && this.staffId.staff && this.staffId.staff[0]) {
      requestReport.staffId = this.staffId.staff[0].staff.id;
    } else {
      console.error('Staff ID not available. Cannot generate report.');
      return;
    }

    if (requestReport.activities === undefined) {
      requestReport.activities = [];
    }

    requestReport.reportId = report.id;
    requestReport.category = this.report.category;
    requestReport.staffAgency = this.profile.agency;
    requestReport.staffSchool = this.staffId.schools[0].id;;

    requestReport.reportName = this.report.reportName; console.log("Request Report is: ", requestReport);
    let startDate = null;
    let endDate = null;

    if (requestReport.startDate != null) {
      startDate = pipe.transform(requestReport.startDate, "yyyy-MM-dd");
      this.reportForm.get("startDate").setValue(startDate);
      requestReport.startDate = startDate;
    }

    if (requestReport.endDate) {
      endDate = pipe.transform(requestReport.endDate, "yyyy-MM-dd");
      this.reportForm.get("endDate").setValue(endDate);
      requestReport.endDate = endDate;
    }

    this.reportService.addScheduledReport(requestReport).subscribe();
    this.modal.dismiss("submitted");
  }

}
